// extracted by css-extract-rspack-plugin
export default {"wrapper":"dZj6V3NNNXEx9qaF","input":"I7MovSr6JUZUbo2e","inputWithTrailing":"Cm4KeCi5nkk09sL8","trailing":"C80l42xDc1wC3CcD"};